import React from "react";
import Lottie from "lottie-react";
import pawAnimation from "../assets/ZtQsy33o9E.json"; // Ensure this path is correct
import { Fullscreen } from "lucide-react"; // Unused in this component but kept if needed elsewhere
import "../css/PawAnimation.css"; // Import the CSS file

const PawAnimation = () => {
  return (
    <div className="paw-animation-container">
      <Lottie 
        animationData={pawAnimation} 
        loop={true} 
        style={{ width: "550px", height: "550px" }} 
        className="paw-animation"
      />
      
      <h2 className="paw-animation-text">Please wait while we load the data...</h2>
    </div>
  );
}

export default PawAnimation;
